import { Fragment } from 'react';
import { id } from '@monorepo/tools/src/lib/types/primitives';

type ISendToReview = {
	creativeIds: id[];
};
export const SendToReviewModal = (props: ISendToReview) => {
	const { creativeIds } = props;
	return (
		<Fragment>
			<div>Send the following creatives to review:</div>
			<span style={{ color: '#4f46e5' }}>
				{creativeIds.length < 6
					? creativeIds.map((creativeId, index) => `${index !== creativeIds.length - 1 ? creativeId + ', ' : creativeId + '.'}`)
					: `${creativeIds.length} creatives`}
			</span>
		</Fragment>
	);
};
